import { jsxs as v, jsx as o } from "react/jsx-runtime";
import { C as c } from "../../index.esm-B8NUmg-c.js";
import { FormErrorMessage as d } from "../FormErrorMessage/index.js";
import { TextInput as f } from "../TextInput/index.js";
import { Typography as g } from "../Typography/index.js";
const j = ({
  name: t,
  label: e,
  errors: r,
  control: m,
  rules: p,
  value: l,
  onChange: n,
  ...s
}) => {
  const u = r && t in r;
  return /* @__PURE__ */ v("div", { children: [
    e && /* @__PURE__ */ o(g, { variant: "bodyS", className: "mb-2", children: e }),
    /* @__PURE__ */ o(
      c,
      {
        name: t,
        control: m,
        rules: p,
        render: ({ field: a }) => /* @__PURE__ */ o(
          f,
          {
            ...a,
            ...s,
            value: a.value || l,
            onChange: (i) => {
              a.onChange(i.target.value), n && n(i.target.value);
            },
            color: u ? "failure" : void 0
          }
        )
      }
    ),
    r && /* @__PURE__ */ o(d, { errors: r, name: t })
  ] });
};
export {
  j as ControlledTextInput
};
